import styled from 'styled-components';

export const SimulationsListByColContainer = styled.div`
  transition: ease-in-out .2s;

  &.fade {
    opacity: 0;
  }

  &.fade.show {
    opacity: 1;
  }
`;

export const SimulationsListByColContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  grid-gap: 24px;
  padding: 22px 0;
  transition: ease-in-out .2s;
`;
